var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-black-bg"},[(_vm.count === 4)?_c('span',[_vm._v(" Ready")]):_vm._e(),(_vm.count !== 4)?_c('span',[_vm._v(_vm._s(_vm.count))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }